module.exports = __webpack_public_path__ + "img/rings.95c80769.svg";